"use strict";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function countdown() {
    return {
        time: 0,
        interval: null,
        isPrePromotion: true,
        promotionStartDate: new Date("2025-01-29T11:00:00Z"),
        promotionEndDate: new Date("2025-02-06T21:59:59Z"),
        isPromotionEnded: false,
        get formattedTime () {
            const hours = Math.floor(this.time / 3600).toString().padStart(2, "0");
            const minutes = Math.floor(this.time % 3600 / 60).toString().padStart(2, "0");
            const seconds = (this.time % 60).toString().padStart(2, "0");
            return `${hours}:${minutes}:${seconds}`;
        },
        get hours () {
            return Math.floor(this.time / 3600);
        },
        get minutes () {
            return Math.floor(this.time % 3600 / 60);
        },
        get seconds () {
            return this.time % 60;
        },
        formatNumber: (num)=>{
            return num.toString().padStart(2, "0");
        },
        start () {
            return _async_to_generator(function*() {
                window.promotionStartDate = this.promotionStartDate;
                // try {
                //   const r = await fetch('https://samsungconfig.gcraft.tech/api/promotions').then((res) => res.json());
                //   console.log(r);
                //   this.promotionStartDate = new Date(r.promotionStartDate + 'Z');
                //   this.promotionEndDate = new Date(r.promotionEndDate + 'Z');
                // } catch (error) {
                //   console.error(error);
                // }
                this.isPrePromotion = new Date() < this.promotionStartDate;
                window.promotionStartDate = this.promotionStartDate;
                console.log(this.isPrePromotion);
                console.log(this.promotionStartDate, new Date());
                setTimeout(()=>{
                    this.isPrePromotion = false;
                }, this.promotionStartDate.getTime() - new Date().getTime());
                this.isPromotionEnded = new Date() > this.promotionEndDate;
                setTimeout(()=>{
                    this.isPromotionEnded = true;
                }, this.promotionEndDate.getTime() - new Date().getTime());
                this.time = Math.floor((this.promotionEndDate.getTime() - new Date().getTime()) / 1000);
                this.interval = setInterval(()=>{
                    if (this.time > 0) {
                        if (this.time === 1) this.isPromotionEnded = true;
                        this.time--;
                    } else clearInterval(this.interval || 0); // Stop when it reaches 0
                }, 1000);
            }).apply(this);
        },
        reset () {
            clearInterval(this.interval || 0);
            this.start();
        }
    };
}
if (typeof window !== "undefined") window.countdown = countdown;

//# sourceMappingURL=index.5c3c8a85.js.map
